module.exports = __webpack_public_path__ + "src/app/_content/imgs/bmw/id_module/BMW_Logo.svg?6aba7c97aff452114cab52747378adfd";